// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMIN_USER = "Modr\u00fd kon\u00edk";
export const AUTHOR = "autor";
export const BLOGPOST_COMMENT_DELETED_BY_AUTHOR = "Autor koment\u00e1r zmazal";
export const BLOGPOST_COMMENT_DELETED_BY_SOMEONE = "Koment\u00e1r bol odstr\u00e1nen\u00fd";
export const COMMENT_DELETED_BECAUSE_reason = "D\u00f4vod: %(reason)s";
export const COMMENT_DELETED_BY_ADMIN = "Odpove\u010f bola odstr\u00e1nen\u00e1";
export const COMMENT_DELETED_BY_AUTHOR = "Autor odpove\u010f zmazal";
export const FORUM_CANT_SEE_ANSWER = "Pridaj s\u00fa\u0165a\u017en\u00fa odpove\u010f a uvid\u00ed\u0161 odpovede ostatn\u00fdch";
export const GROUP_COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie koment\u00e1ra";
export const SHOW = "Zobraz";
